var _slicedToArray = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/inherits");

var LuaVisitor = require('../antlr/LuaVisitor').LuaVisitor;

var LuaParser = require('../antlr/LuaParser').LuaParser;

var symbols = require('./symbols');

var RuntimeError = require('./RuntimeError');

var ReturnManager = require('./ReturnManager');

var Globals = require('./Globals');

var Visitor =
/*#__PURE__*/
function (_LuaVisitor) {
  "use strict";

  _inherits(Visitor, _LuaVisitor);

  function Visitor(_ref) {
    var _this;

    var mem = _ref.mem;

    _classCallCheck(this, Visitor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Visitor).call(this));
    _this.mem = mem;
    _this.return = new ReturnManager();
    return _this;
  }

  _createClass(Visitor, [{
    key: "getLeftRightHandExp",
    value: function getLeftRightHandExp(ctx) {
      return [0, 1].map(ctx.exp.bind(ctx)).map(this.visit.bind(this));
    }
  }, {
    key: "fnFromFuncbody",
    value: function fnFromFuncbody(funcbody) {
      var _this2 = this;

      return function (args) {
        var _funcbody$accept = funcbody.accept(_this2),
            _funcbody$accept2 = _slicedToArray(_funcbody$accept, 2),
            params = _funcbody$accept2[0],
            block = _funcbody$accept2[1];

        _this2.return.insideFnPush();

        _this2.mem.push();

        for (var i = 0; i < Math.min(args.length, params.length); i++) {
          _this2.mem.declareVar(params[i], args[i]);

          _this2.mem.setVar(params[i], args[i]);
        }

        block.accept(_this2);

        _this2.mem.pop();

        _this2.return.insideFnPop();

        if (_this2.return.return()) return _this2.return.returnPop();
      };
    }
  }, {
    key: "visitChunk",
    value: function visitChunk(ctx) {
      this.visitChildren(ctx);
    }
  }, {
    key: "visitBlock",
    value: function visitBlock(ctx) {
      this.mem.push();
      var i = 0;
      var stat;

      while ((stat = ctx.stat(i++)) !== null) {
        if (stat instanceof LuaParser.StatBreakContext) {
          if (this.return.insideLoop()) {
            this.return.breakLoopPush();
            break;
          }
        }

        stat.accept(this);

        if (this.return.return()) {
          this.mem.pop();
          return;
        }
      }

      if (ctx.retstat()) {
        var value = ctx.retstat().accept(this);
        if (this.return.insideFn()) this.return.returnPush(value);
      }

      this.mem.pop();
    }
  }, {
    key: "visitRetstat",
    value: function visitRetstat(ctx) {
      return ctx.exp() ? ctx.exp().accept(this) : undefined;
    } //noinspection JSMethodCanBeStatic

  }, {
    key: "visitStatBreak",
    value: function visitStatBreak(ctx) {
      return symbols.break;
    }
  }, {
    key: "visitStatIf",
    value: function visitStatIf(ctx) {
      var i = 0;

      for (var exp = ctx.exp(i); exp; exp = ctx.exp(++i)) {
        if (exp.accept(this)) {
          ctx.block(i).accept(this);
          return;
        }
      }

      if (ctx.block(i)) ctx.block(i).accept(this);
    }
  }, {
    key: "visitStatWhile",
    value: function visitStatWhile(ctx) {
      var cond = ctx.exp(0);
      var block = ctx.block(0);
      this.return.insideLoopPush();

      while (cond.accept(this)) {
        block.accept(this);

        if (this.return.breakLoop()) {
          this.return.breakLoopPop();
          break;
        }
      }

      this.return.insideLoopPop();
    }
  }, {
    key: "visitStatFor",
    value: function visitStatFor(ctx) {
      var _this3 = this;

      this.mem.push();
      var name = ctx.NAME(0).getText();
      this.mem.declareVar(name);
      var from = ctx.exp(0).accept(this);
      var to = ctx.exp(1).accept(this);
      var step = ctx.exp(2) ? ctx.exp(2).accept(this) : from < to ? 1 : -1;
      this.return.insideLoopPush();

      var loop_body = function loop_body(counter) {
        _this3.mem.setVar(name, counter);

        ctx.block(0).accept(_this3);

        if (_this3.return.breakLoop()) {
          _this3.return.breakLoopPop();

          return true;
        }

        return false;
      };

      if (step > 0) {
        for (var counter = from; counter <= to; counter += step) {
          if (loop_body(counter)) break;
        }
      } else {
        for (var _counter = from; _counter >= to; _counter += step) {
          if (loop_body(_counter)) break;
        }
      }

      this.return.insideLoopPop();
      this.mem.pop();
    }
  }, {
    key: "visitStatVarDeclaration",
    value: function visitStatVarDeclaration(ctx) {
      var name = ctx.NAME().getText();
      if (this.mem.hasLocalVar(name)) throw new RuntimeError("Local variable \"".concat(name, "\" already exists"));
      this.mem.declareVar(name);
      if (ctx.exp(0)) this.mem.setVar(name, ctx.exp(0).accept(this));
    }
  }, {
    key: "visitStatAssignment",
    value: function visitStatAssignment(ctx) {
      var variable = ctx.variable().accept(this);
      var val = ctx.exp(0).accept(this);
      variable.set(val);
      return val;
    }
  }, {
    key: "visitStatFunction",
    value: function visitStatFunction(ctx) {
      var name = ctx.funcname().accept(this);
      var fn = this.fnFromFuncbody(ctx.funcbody());
      this.mem.setVar(name, fn);
      return fn;
    }
  }, {
    key: "visitStatLocalFunction",
    value: function visitStatLocalFunction(ctx) {
      var name = ctx.funcname().accept(this);
      var fn = this.fnFromFuncbody(ctx.funcbody());
      if (this.mem.hasLocalVar(name)) throw new RuntimeError("Local function \"".concat(name, "\" already exists"));
      this.mem.declareVar(name);
      this.mem.setVar(name, fn);
      return fn;
    }
  }, {
    key: "visitFuncbody",
    value: function visitFuncbody(ctx) {
      var params = ctx.parlist() ? ctx.parlist().accept(this) : [];
      return [params, ctx.block()];
    }
  }, {
    key: "visitNamelist",
    value: function visitNamelist(ctx) {
      var namelist = [];
      var i = 0;
      var name;

      while ((name = ctx.NAME(i++)) !== null) {
        namelist.push(name.getText());
      }

      return namelist;
    }
  }, {
    key: "visitParlist",
    value: function visitParlist(ctx) {
      return ctx.namelist().accept(this);
    }
  }, {
    key: "visitFunctioncall",
    value: function visitFunctioncall(ctx) {
      var fn = ctx.variable().accept(this).get();
      var args = ctx.args().accept(this);
      return fn(args);
    }
  }, {
    key: "visitArgs",
    value: function visitArgs(ctx) {
      return ctx.explist() ? ctx.explist().accept(this) : [];
    }
  }, {
    key: "visitExplist",
    value: function visitExplist(ctx) {
      var explist = [];
      var i = 0;
      var exp;

      while ((exp = ctx.exp(i++)) !== null) {
        explist.push(exp.accept(this));
      }

      return explist;
    }
  }, {
    key: "visitStatFunctioncall",
    value: function visitStatFunctioncall(ctx) {
      return this.visit(ctx.functioncall());
    }
  }, {
    key: "visitExpVarexp",
    value: function visitExpVarexp(ctx) {
      return this.visit(ctx.varexp());
    }
  }, {
    key: "visitVarexp",
    value: function visitVarexp(ctx) {
      if (ctx.variable()) return ctx.variable().accept(this).get();else if (ctx.functioncall()) return ctx.functioncall().accept(this);else return ctx.exp().accept(this);
    } //noinspection JSMethodCanBeStatic

  }, {
    key: "visitVariable",
    value: function visitVariable(ctx) {
      var _this4 = this;

      var variable = ctx.variable(0);
      var exp = ctx.exp(0);
      var name = ctx.NAME(0);

      if (variable && exp) {
        var v = variable.accept(this).get();
        return {
          get: function get() {
            return v.get(exp.accept(_this4));
          },
          set: function set(val) {
            return v.set(exp.accept(_this4), val);
          }
        };
      } else if (variable && name) {
        var _v = variable.accept(this).get();

        var n = name.getText();
        return {
          get: function get() {
            return _v.get(n);
          },
          set: function set(val) {
            return _v.set(n, val);
          }
        };
      }

      return {
        get: function get() {
          return _this4.mem.getVar(name.getText());
        },
        set: function set(val) {
          return _this4.mem.setVar(name.getText(), val);
        }
      };
    } //noinspection JSMethodCanBeStatic

  }, {
    key: "visitFuncname",
    value: function visitFuncname(ctx) {
      return ctx.getText();
    } //noinspection JSMethodCanBeStatic

  }, {
    key: "visitExpNil",
    value: function visitExpNil() {
      return symbols.nil;
    } //noinspection JSMethodCanBeStatic

  }, {
    key: "visitExpFalse",
    value: function visitExpFalse() {
      return false;
    } //noinspection JSMethodCanBeStatic

  }, {
    key: "visitExpTrue",
    value: function visitExpTrue() {
      return true;
    } //noinspection JSMethodCanBeStatic

  }, {
    key: "visitExpNumber",
    value: function visitExpNumber(ctx) {
      return Number.parseFloat(ctx.getText());
    } //noinspection JSMethodCanBeStatic

  }, {
    key: "visitExpString",
    value: function visitExpString(ctx) {
      return ctx.getText().slice(1, -1);
    }
  }, {
    key: "visitExpTableconstruct",
    value: function visitExpTableconstruct(ctx) {
      return this.visit(ctx.tableconstructor());
    }
  }, {
    key: "visitTableconstructor",
    value: function visitTableconstructor(ctx) {
      if (!ctx.fieldlist()) return new Map();
      var counter = 1;
      var table_entries = ctx.fieldlist().accept(this).map(function (_ref2) {
        var key = _ref2.key,
            value = _ref2.value;
        return [key === null ? counter++ : key, value];
      });
      return new Map(table_entries);
    }
  }, {
    key: "visitFieldlist",
    value: function visitFieldlist(ctx) {
      var fieldlist = [];

      for (var i = 0, field = ctx.field(i); field !== null; field = ctx.field(++i)) {
        fieldlist.push(field.accept(this));
      }

      return fieldlist;
    }
  }, {
    key: "visitField",
    value: function visitField(ctx) {
      var exps = [];

      for (var i = 0, exp = ctx.exp(i); exp !== null; exp = ctx.exp(++i)) {
        exps.push(exp.accept(this));
      }

      var has_exp_key = exps.length === 2;
      var name = ctx.NAME(0);
      return {
        key: has_exp_key ? exps[0] : name ? name.getText() : null,
        value: has_exp_key ? exps[1] : exps[0]
      };
    }
  }, {
    key: "visitExpFunctiondef",
    value: function visitExpFunctiondef(ctx) {
      return this.visit(ctx.functiondef());
    }
  }, {
    key: "visitFunctiondef",
    value: function visitFunctiondef(ctx) {
      return this.fnFromFuncbody(ctx.funcbody());
    }
  }, {
    key: "visitExpPow",
    value: function visitExpPow(ctx) {
      var _this$getLeftRightHan = this.getLeftRightHandExp(ctx).map(Number),
          _this$getLeftRightHan2 = _slicedToArray(_this$getLeftRightHan, 2),
          lh = _this$getLeftRightHan2[0],
          rh = _this$getLeftRightHan2[1];

      return Math.pow(lh, rh);
    }
  }, {
    key: "visitExpUnaryOp",
    value: function visitExpUnaryOp(ctx) {
      var value = ctx.exp().accept(this);

      switch (ctx.operatorUnary().getText()) {
        case 'not':
          return !value;

        case '#':
          return value.length;

        case '-':
          return value * -1;
      }
    }
  }, {
    key: "visitExpMulDivOp",
    value: function visitExpMulDivOp(ctx) {
      var _this$getLeftRightHan3 = this.getLeftRightHandExp(ctx).map(Number),
          _this$getLeftRightHan4 = _slicedToArray(_this$getLeftRightHan3, 2),
          lh = _this$getLeftRightHan4[0],
          rh = _this$getLeftRightHan4[1];

      switch (ctx.operatorMulDivMod().getText()) {
        case '*':
          return lh * rh;

        case '/':
          return lh / rh;

        case '%':
          return lh % rh;
      }
    }
  }, {
    key: "visitExpAddSubOp",
    value: function visitExpAddSubOp(ctx) {
      var _this$getLeftRightHan5 = this.getLeftRightHandExp(ctx),
          _this$getLeftRightHan6 = _slicedToArray(_this$getLeftRightHan5, 2),
          lh = _this$getLeftRightHan6[0],
          rh = _this$getLeftRightHan6[1];

      switch (ctx.operatorAddSub().getText()) {
        case '+':
          return lh + rh;

        case '-':
          return lh - rh;
      }
    }
  }, {
    key: "visitExpStrcat",
    value: function visitExpStrcat(ctx) {
      var _this$getLeftRightHan7 = this.getLeftRightHandExp(ctx).map(function (_) {
        return _.toString();
      }),
          _this$getLeftRightHan8 = _slicedToArray(_this$getLeftRightHan7, 2),
          lh = _this$getLeftRightHan8[0],
          rh = _this$getLeftRightHan8[1];

      return lh + rh;
    }
  }, {
    key: "visitExpComparsionOp",
    value: function visitExpComparsionOp(ctx) {
      var _this$getLeftRightHan9 = this.getLeftRightHandExp(ctx),
          _this$getLeftRightHan10 = _slicedToArray(_this$getLeftRightHan9, 2),
          lh = _this$getLeftRightHan10[0],
          rh = _this$getLeftRightHan10[1];

      switch (ctx.operatorComparison().getText()) {
        case '<':
          return Number(lh) < Number(rh);

        case '>':
          return lh > rh;

        case '<=':
          return lh <= rh;

        case '>=':
          return lh >= rh;

        case '~=':
          //noinspection EqualityComparisonWithCoercionJS
          return lh != rh;

        case '==':
          //noinspection EqualityComparisonWithCoercionJS
          return lh == rh;
      }
    }
  }, {
    key: "visitExpAndOp",
    value: function visitExpAndOp(ctx) {
      var _this$getLeftRightHan11 = this.getLeftRightHandExp(ctx),
          _this$getLeftRightHan12 = _slicedToArray(_this$getLeftRightHan11, 2),
          lh = _this$getLeftRightHan12[0],
          rh = _this$getLeftRightHan12[1];

      return lh && rh;
    }
  }, {
    key: "visitExpOrOp",
    value: function visitExpOrOp(ctx) {
      var _this$getLeftRightHan13 = this.getLeftRightHandExp(ctx),
          _this$getLeftRightHan14 = _slicedToArray(_this$getLeftRightHan13, 2),
          lh = _this$getLeftRightHan14[0],
          rh = _this$getLeftRightHan14[1];

      return lh || rh;
    }
  }]);

  return Visitor;
}(LuaVisitor);

module.exports = Visitor;